import { useAtomValue } from 'jotai';
import { Suspense } from 'react';

import { Loading, Typography } from '@crossnokaye/ux-common';

import { rightPaneExpandedAtom } from '@/components/right-pane/right-pane.state';

import { SelectionsTemplate } from './components/_templates/selections-template';
import { SelectionsActionSection } from './components/selections-action-section';
import { SelectionsList } from './components/selections-list/selections-list';
import { SelectionsSearchInput } from './components/selections-search-input';

export const SelectionsSidebar = () => {
  const showRightPane = useAtomValue(rightPaneExpandedAtom);

  // Don't render anything when collapsed - the header button handles opening
  if (!showRightPane) {
    return null;
  }

  return (
    <Suspense
      fallback={
        <div className="flex flex-col items-center justify-center p-4 text-sm text-muted-foreground text-center">
          <Loading size="sm" />
          <Typography variant="body">Loading devices...</Typography>
        </div>
      }
    >
      <SelectionsTemplate
        searchInput={<SelectionsSearchInput />}
        listActions={<SelectionsActionSection />}
      >
        <SelectionsList />
      </SelectionsTemplate>
    </Suspense>
  );
};
